import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomMaterialModule } from 'src/app/material-module/material.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';
import { ResourcefulIndexModule } from 'src/app/shared/resourceful-index/resourceful-index.module';
import { EditDisposizioneCompagniaComponent } from './dialogs/edit/edit.component';
import { DisposizioneAllegatiDialogComponent } from './dialogs/allegati/disposizione-allegati.component';
import { DisposizioniCompagnieComponent } from './disposizioni-compagnie.component';

@NgModule({
  declarations: [DisposizioniCompagnieComponent, EditDisposizioneCompagniaComponent, DisposizioneAllegatiDialogComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    ResourcefulIndexModule,
    CustomFormControlsModule,
  ],
  exports: [DisposizioniCompagnieComponent, EditDisposizioneCompagniaComponent]
})
export class DisposizioniCompagnieModule { }
